import React from 'react';
import CycleDirectory from './CycleDirectory';
import CreateNewCycle from './CreateNewCycle';
import _ from 'lodash';
import {observer} from 'mobx-react';

const LandingContainer = ({cycles, uiState, onCheckInCreated, onCycleDeleted, onCycleArchived, onCycleClicked}) => {
  if (_.isEmpty(cycles)) {
    return <CreateNewCycle onCheckInCreated={onCheckInCreated}/>;
  } else {
    return <CycleDirectory
            cycles={cycles}
            uiState={uiState}
            onCheckInCreated={onCheckInCreated}
            onCycleDeleted={onCycleDeleted}
            onCycleArchived={onCycleArchived}
            onCycleClicked={onCycleClicked} />;
  }
};

export default observer(LandingContainer);
